import { LDSSkeleton } from "@resmed/lumina-design-system";

/** Placeholder that mirrors the LDSDropDown layout (label + input box). */
const SkeletonDropdown = () => (
  <div className="lds-flex lds-flex-col lds-gap-1.5">
    <LDSSkeleton shape="rectangle" width="4.5rem" height="0.75rem" />
    <LDSSkeleton shape="rectangle" width="100%" height="2.625rem" borderRadius="0.375rem" />
  </div>
);

export default SkeletonDropdown;
